/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/11/22, 3:19 PM
 *
 */

import { ApiResponse } from 'types/api';

import { Test } from 'features/members/types';

import { privateAgent } from 'config/axios';

export const listTests = async (): Promise<Test[]> => {
  const response = await privateAgent.get<ApiResponse<Test[]>>(`test/categories`);
  return response.data.data;
};
